import { useQuery } from "@tanstack/react-query";
import { useMakeAuthedRequest } from "shared/api/authRequest";

export default function useGetUser(enabled?: boolean) {
  const makeRequest = useMakeAuthedRequest();

  const getUserMe = async () => {
    const result = await makeRequest<any>({
      method: "get",
      url: `/api/ConnectUsers/me`,
    });

    return result;
  };

  return useQuery({
    queryKey: ["user", "me"],
    queryFn: getUserMe,
    enabled: enabled ?? true,
  });
}
